import { functionsService } from "..";
import axios from "axios";
import { Vehicle } from "../../data/models/Car";

const LIMIT = process.env.REACT_APP_LIMIT || 10;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class functionsStore {
  async getSomething() {
    try {
      const response = await functionsService.getSomething();
      return response.amazon_vouchers;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  getCars = async (
    filters?: Record<string, string[]>,
    sort?: string,
    page: number = 1,
    vehicleToggle?: boolean
  ): Promise<any> => {
    const filterToParamMap: Record<string, string> = {
      "Tip vozila": "type",
      "Model vozila": "family",
      "Tip goriva": "fuel_hr",
      //"Verzija motora": "model_engine",
      "Vrsta mjenjača": "gear_type",
      Grad: "dealer_city",
      Boja: "color",
    }; //UTM params are not defined here so they are ignored even if they appear in the URL

    try {
      let minPrice: number | null = null;
      let maxPrice: number | null = null;

      if (filters?.["rasponcijene"] && filters["rasponcijene"].length > 0) {
        const [min, max] = (filters["rasponcijene"] ?? []).map(Number);
        minPrice = !isNaN(min) ? min : null;
        maxPrice = !isNaN(max) ? max : null;
      }

      // Generiranje filter parametara za sve ostale filtre
      const otherFilterParams = filters
        ? Object.entries(filters)
            .filter(([key]) => key !== "rasponcijene") // Izuzimanje "Raspon cijene"
            .filter(([_, values]) => values.length > 0) // Ignoriranje praznih vrijednosti
            .map(([key, values]) => {
              const paramKey = filterToParamMap[key]; // Mapiranje ključeva filtera na API parametre
              if (!paramKey) return null; // Ignoriraj ako ne postoji u mapi
              const paramValue = values.map(encodeURIComponent).join(","); // Spajanje vrijednosti filtera
              return `${paramKey}=${paramValue}`;
            })
            .filter(Boolean) // Uklanjanje `null` vrijednosti
            .join("&")
        : "";
      //console.log("Filter url backend:", otherFilterParams);

      // Dodavanje cijena u upit
      const priceParams = [];
      if (minPrice !== null) priceParams.push(`min_price=${minPrice}`);
      if (maxPrice !== null) priceParams.push(`max_price=${maxPrice}`);

      // Kombiniranje svih parametara
      let queryParams = "";
      if (sort !== "") {
        const sortParam = `sort_by_price=${sort}`;
        queryParams = [sortParam, otherFilterParams, ...priceParams]
          .filter(Boolean)
          .join("&");
      } else {
        queryParams = [otherFilterParams, ...priceParams]
          .filter(Boolean)
          .join("&");
      }

      // Generiranje URL-a
      const apiUrl = `${API_BASE_URL}/vehicles?limit=${LIMIT}&brand=CITROEN${
        queryParams ? `&${queryParams}` : ""
      }&page=${page}${
        vehicleToggle ? "" : `&vehicle_state_hr=${vehicleToggle}`
      }`;
      //console.log("Cijeli url backend:", apiUrl);
      // Slanje zahtjeva
      const response = await axios.get(apiUrl);
      return response.data;
    } catch (error) {
      console.error("Greška pri izvršenju:", error);
      if (axios.isAxiosError(error)) {
        console.error("Axios error:", error.response?.data || error.message);
      } else {
        console.error("Neočekivana greška:", error);
      }
      throw error;
    }
  };

  getCarDataById = async (id: string | undefined): Promise<Vehicle | null> => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/vehicles/${id}/details`
      );
      return response.data;
    } catch (err) {
      console.log(err);
      return null;
    }
  };
}

const functionsStoreInstance = new functionsStore();
export default functionsStoreInstance;
